// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SurveySaveQuestionResultRequestModel {
    static getAttributeTypeMap() {
        return SurveySaveQuestionResultRequestModel.attributeTypeMap;
    }
}
SurveySaveQuestionResultRequestModel.discriminator = undefined;
SurveySaveQuestionResultRequestModel.additionalProperties = false;
SurveySaveQuestionResultRequestModel.attributeTypeMap = [
    {
        "name": "surveySessionId",
        "baseName": "surveySessionId",
        "type": "number"
    },
    {
        "name": "questionId",
        "baseName": "questionId",
        "type": "number"
    },
    {
        "name": "answerId",
        "baseName": "answerId",
        "type": "number"
    },
    {
        "name": "answerValue",
        "baseName": "answerValue",
        "type": "string"
    },
];
//# sourceMappingURL=surveySaveQuestionResultRequestModel.js.map